<script setup lang="ts">
import { storeToRefs } from 'pinia'

import NotifyItem from './NotifyItem.vue'
import { useNotifyStore } from '../../stores/notify'

const { notifications } = storeToRefs(useNotifyStore())
</script>

<template>
  <TransitionGroup v-if="notifications.length > 0"
                   name="bx-notify-fade"
                   tag="div"
                   class="bx-notify bx-typo--notify">
    <NotifyItem v-for="(item) in notifications"
                :id="item.id"
                :key="`notify-item-${item.id}`"
                :delay="item.delay"
                :type="item.type"
                :title="item.title"
                :message="item.message" />
  </TransitionGroup>
</template>
